import React from "react";
import {
    Box,
    Typography,
    LinearProgress,
    Link,
    IconButton,
    Tooltip,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import "./FirmwareUpdateStatus.css";

interface FirmwareUpdateStatusProps {
    status: "progress" | "completed";
    version?: string;
    currentStep?: number;
    totalSteps?: number;
    progress?: number;
    statusText?: string;
    onClose?: () => void;
}

const FirmwareUpdateStatus: React.FC<FirmwareUpdateStatusProps> = ({
    status,
    version = "",
    currentStep = 0,
    totalSteps = 0,
    progress = 0,
    statusText = "",
    onClose,
}) => {
    return (
        <>
            <Box className="fw-container">
                <Box className="fw-header">
                    {status === "progress" ? (
                        <>
                            <Typography variant="body2" className="fw-title">
                                Firmware update is in progress.&nbsp;
                                {/* <Link href="#" underline="hover" className="fw-link">
                                    Release Notes ({version})
                                </Link> */}
                            </Typography>

                            <Box className="fw-progress-section">
                                <Box className="fw-status">
                                    <Tooltip title={statusText} placement="top">
                                        <Typography
                                            variant="body2"
                                            className="fw-status-text"
                                        >
                                            {statusText}
                                        </Typography>
                                    </Tooltip>
                                    <Typography variant="body2" className="fw-step-count">
                                        ({currentStep} of {totalSteps} steps)
                                    </Typography>
                                </Box>

                                {currentStep === 1 && (
                                    <div className="fw-progress-bar-wrapper">
                                        <Box className="fw-progress-bar">
                                            <LinearProgress
                                                variant="determinate"
                                                value={progress}
                                                sx={{
                                                    height: 6,
                                                    borderRadius: 3,
                                                    backgroundColor: "#E5E7EB",
                                                    "& .MuiLinearProgress-bar": {
                                                        backgroundColor: "#22C55E",
                                                    },
                                                }}
                                            />
                                        </Box>
                                        <Typography variant="body2">{progress}%</Typography>
                                    </div>
                                )}
                            </Box>
                        </>
                    ) : (
                        <>
                            <Box className="fw-complete-box">
                                <Typography variant="body2" className="fw-complete-text">
                                    Firmware update completed.
                                </Typography>
                                <Typography variant="body2" className="fw-whats-new">
                                    {/* Find out{" "}
                                    <Link href="#" underline="hover" className="fw-link">
                                        What’s New&nbsp;!
                                    </Link> */}
                                </Typography>
                            </Box>
                            <IconButton size="small" onClick={onClose} className="fw-close-btn">
                                <CloseIcon fontSize="small" />
                            </IconButton>
                        </>
                    )}
                </Box>
            </Box>

            {status != 'completed' && <p className="fw-footer-text">
                Do not power off or disconnect your device.
            </p>}
        </>
    );
};

export default FirmwareUpdateStatus;